import { reducerKey } from './RcsResultsReducer';

export function rcsResults(state) {
  return state.get(reducerKey);
}

export function rcsResultsProducts(state) {
  return rcsResults(state).get('products');
}

export function getProductsForSubstance(state, { substanceId }) {
  const products = rcsResultsProducts(state);
  return products
    .get(substanceId)
    .valueSeq()
    .toArray()
    .map((product) => product.toJS());
}
